// NOTE: These values are used in API calls
export enum TextAlignment {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}
